import { isDateNotInFuture, isFullySpecifiedDate } from 'app/forms/validations/common';
import isBirthNumber from 'app/forms/validations/isBirthNumber';
import isBusinessIn from 'app/forms/validations/isBusinessIn';
import isBusinessName from 'app/forms/validations/isBusinessName';
import isFirstName from 'app/forms/validations/isFirstName';
import isMunicipality from 'app/forms/validations/isMunicipality';
import isStreet from 'app/forms/validations/isStreet';
import isStreetNumber from 'app/forms/validations/isStreetNumber';
import isSurname from 'app/forms/validations/isSurname';
import isZipCode from 'app/forms/validations/isZipCode';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const CLIENT_SEARCH_FORM_NAME = 'clientSearch-filter';

const { firstName, surname, birthDate, personIn, businessIn, businessName, municipality, street, streetNo, zipCode } =
	COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	surname,
	firstName,
	birthDate,
	personIn,
	businessIn,
	businessName,
	municipality,
	street,
	streetNo,
	zipCode,
};

export default () => ({
	[FIELDS.surname]: {
		deepPath: [FIELDS.surname],
		validations: [isSurname()],
	},
	[FIELDS.firstName]: {
		deepPath: [FIELDS.firstName],
		validations: [isFirstName()],
	},
	[FIELDS.birthDate]: {
		deepPath: [FIELDS.birthDate],
		validations: [isFullySpecifiedDate(), isDateNotInFuture()],
	},
	[FIELDS.personIn]: {
		deepPath: [FIELDS.personIn],
		validations: [isBirthNumber()],
	},
	[FIELDS.businessIn]: {
		deepPath: [FIELDS.businessIn],
		validations: [isBusinessIn()],
	},
	[FIELDS.businessName]: {
		deepPath: [FIELDS.businessName],
		validations: [isBusinessName()],
	},
	[FIELDS.municipality]: {
		deepPath: [FIELDS.municipality],
		validations: [isMunicipality()],
	},
	[FIELDS.street]: {
		deepPath: [FIELDS.street],
		validations: [isStreet()],
	},
	[FIELDS.streetNo]: {
		deepPath: [FIELDS.streetNo],
		validations: [isStreetNumber()],
	},
	[FIELDS.zipCode]: {
		deepPath: [FIELDS.zipCode],
		validations: [isZipCode()],
	},
});
